import { Box, Chip, Typography } from '@mui/material';

import { ReactComponent as VerticalDotsIcon } from 'assets/vertical-dots.svg';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { BusinessType } from 'store/slices/businessesSlice';
import Logo from '../Logo';

import muiStyles, { primary, secondary } from './muiStyles';
import styles from './styles.module.css';
import { statisticsData, widgetValue } from './utils';

const Card = ({
  data,
  onSettingsClick,
}: {
  data: BusinessType;
  onSettingsClick: (e: MouseEvent<SVGSVGElement>, data: BusinessType) => void;
}) => {
  const { businessId, name, logoUrl, category, activeDealCount, wonValue, successRate, industry } =
    data;

  return (
    <Box
      sx={muiStyles.cardContainer}
      component={Link}
      to={`${RoutePaths.Businesses}/${businessId}`}
      key={businessId}
    >
      <Box sx={muiStyles.header}>
        <Box sx={muiStyles.metaData}>
          <Box sx={muiStyles.logo}>
            <Logo logo={logoUrl} />
          </Box>
          <Box sx={muiStyles.title}>
            <Typography variant='responsiveHeading4'>{name}</Typography>
            <Box sx={muiStyles.chipsContainer}>
              <Chip sx={primary} label={category} />
              <Chip sx={secondary} label={industry} />
            </Box>
          </Box>
        </Box>
        <Box sx={muiStyles.optionMenu}>
          <VerticalDotsIcon
            className={styles['vertical-icon']}
            onClick={(e: MouseEvent<SVGSVGElement>) => {
              e.preventDefault();
              onSettingsClick(e, data);
            }}
          />
        </Box>
      </Box>
      <Box sx={muiStyles.widgetContainer}>
        {statisticsData(activeDealCount, wonValue, successRate).map(
          ({ value, formattedValue, label }) => {
            const widgetValueMuiStyles = label === 'Success Rate' ? widgetValue(value) : {};

            return (
              <Box sx={muiStyles.widget} key={label}>
                <Typography sx={{ ...widgetValueMuiStyles }} variant='buttonMedium'>
                  {formattedValue}
                </Typography>
                <Typography>{label}</Typography>
              </Box>
            );
          },
        )}
      </Box>
    </Box>
  );
};

export default Card;
